import { render, staticRenderFns } from "./WorldHelpLabel.vue?vue&type=template&id=6e9cee72&scoped=true&"
import script from "./WorldHelpLabel.vue?vue&type=script&lang=js&"
export * from "./WorldHelpLabel.vue?vue&type=script&lang=js&"
import style0 from "./WorldHelpLabel.vue?vue&type=style&index=0&id=6e9cee72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9cee72",
  null
  
)

export default component.exports